import {Component, OnInit, TemplateRef} from '@angular/core';
import {TemplateRefService} from '../../../core/service/template-ref.service';

@Component({
  selector: 'app-template-ref',
  templateUrl: './template-ref.component.html',
  styleUrls: ['./template-ref.component.scss']
})
export class TemplateRefComponent implements OnInit {
  isDoneTempRefSetting = false;

  constructor(public templateRefService: TemplateRefService) { }

  /**
   *
   */
  ngOnInit(): void {
  }

  /**
   * TemplateRef をセットする
   * @param tempRef
   */
  setTempRef(tempRef: TemplateRef<any>) {
    this.templateRefService.noDataTempRef = tempRef;
    setTimeout(() => {
      this.isDoneTempRefSetting = true;
    }, 0);
  }
}
